import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

// confirmDialog function
export function confirmDialog({
  title,
  message,
  confirmText = 'Yes',
  cancelText = 'No',
  onBackdropClick,
}) {
  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent('open-confirm-dialog', {
        detail: { title, message, confirmText, cancelText, resolve, onBackdropClick },
      }),
    );
  });
}

// Provider Component (global dialog listener)
export default function ConfirmationProvider() {
  const [open, setOpen] = useState(false);
  const [ui, setUi] = useState({
    title: '',
    message: '',
    confirmText: 'Yes',
    cancelText: 'No',
    onBackdropClick: false,
  });

  const resolveRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};

      setUi({
        title: detail.title || '',
        message: detail.message || '',
        confirmText: detail.confirmText || 'Yes',
        cancelText: detail.cancelText || 'No',
        onBackdropClick: detail.onBackdropClick || false,
      });

      resolveRef.current = detail.resolve;
      setOpen(true);
    };

    window.addEventListener('open-confirm-dialog', handler);
    return () => window.removeEventListener('open-confirm-dialog', handler);
  }, []);

  const handleClose = (result) => {
    setOpen(false);
    if (resolveRef.current) {
      resolveRef.current(result);
      resolveRef.current = null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => (ui.onBackdropClick ? handleClose('outsideClick') : handleClose(false))}
    >
      <DialogTitle>{ui.title}</DialogTitle>

      <DialogContent>
        <DialogContentText>{ui.message}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant='contained' color='primary' onClick={() => handleClose(true)} autoFocus>
          {ui.confirmText}
        </Button>

        <Button color='inherit' onClick={() => handleClose(false)}>
          {ui.cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
